import { abortNavigation, useCurrentUserProfile, useOAuth } from "#imports";
import type { Role } from "~/enums/role";
import type { Permission } from "~/enums/permission";
import type { PageMeta } from "~/node_modules/nuxt/dist/pages/runtime/composables";
import { getOAuthUser } from "~/utils/oauthUserStorage";

export default defineNuxtRouteMiddleware(async (to: { meta: PageMeta }) => {
  const user = getOAuthUser();

  if (!user) {
    return;
  }
  const permission: Permission | undefined = to.meta.authorize?.permission;

  if (permission !== undefined) {
    const { tokenScopes } = await useOAuth();

    let scopes: string[];
    try {
      scopes = await tokenScopes();
    } catch (error) {
      console.error("[authorizePage] tokenScopes() failed:", error);
      throw error;
    }

    if (!scopes.includes(permission)) {
      return abortNavigation();
    }
  }

  const role: Role | undefined = to.meta.authorize?.role;

  if (role !== undefined) {
    const { currentUserProfile } = await useCurrentUserProfile();

    if (!currentUserProfile || !currentUserProfile.roles.includes(role)) {
      return abortNavigation();
    }
  }
});
